module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-create-entity-button"
  }, [_c('ModalReveal', {
    ref: ("maintenance-" + _vm._uid),
    attrs: {
      "value": _vm.open
    }
  }, [(!_vm.open) ? [(_vm.request) ? _c('button', {
    staticClass: "button success",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_vm._v("Detail")]) : _c('a', {
    staticClass: "fa-stack fa-lg",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_c('i', {
    staticClass: "fa fa-circle fa-stack-2x"
  }), _c('i', {
    staticClass: "fa fa-plus fa-stack-1x fa-inverse"
  })])] : _vm._e(), _c('h2', [_vm._v("Intervention request IR" + _vm._s(_vm.request.id))]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('vehicle', {
    attrs: {
      "type": "compact-card",
      "item": _vm.request.vehicle
    }
  })], 1), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Description")]), _c('div', [_vm._v(_vm._s(_vm.request.description))]), _c('label', [_vm._v("Created at")]), _c('div', [_vm._v(" " + _vm._s(_vm.$dateFormat(_vm.request.created_at, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))]), _c('label', [_vm._v("Expiry")]), _c('div', [_vm._v(" " + _vm._s(_vm.$dateFormat(_vm.request.expiry, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))])])]), (_vm.request.linked_requests.length) ? _c('MaintenanceRequestList', {
    attrs: {
      "request": _vm.request,
      "filters": _vm.filters,
      "listing-type": "detail-listing"
    }
  }) : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-407df6d7!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/DetailInterventionRequestReveal.vue
// module id = 2439
// module chunks = 1